import NewsletterSuccessIcon from "@/components/shared/icons/NewsletterSuccessIcon"
import colors from "@/lib/theme/colors"
import styled from "@emotion/styled"
import { Typography } from "@mui/material"
import { NEWSLETTER_THANK_YOU_HEADING } from "./newsletterContent"

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  width: 100%;
  padding-bottom: 8px;
`

const Heading = styled(Typography)`
  color: ${colors.white};
  font-size: 24px;
  font-weight: 400;
  line-height: normal;
  text-align: center;
`

const NewsletterThankYou = (): React.ReactElement => {
  return (
    <Wrapper>
      <NewsletterSuccessIcon aria-hidden />
      <Heading variant="h3">{NEWSLETTER_THANK_YOU_HEADING}</Heading>
    </Wrapper>
  )
}

export default NewsletterThankYou
